export const MIN_PASS_LENGTH = 8
